import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { initializeFirestore, persistentLocalCache } from "firebase/firestore";
import { getRemoteConfig, fetchAndActivate } from "firebase/remote-config";
import siteConfig from "./index";

const firebaseConfig = {
  apiKey: "AIzaSyD7te9JCNNs_uu3tULYhN6N_A1G9Ss7TWk",
  authDomain: "kuramatura-7a9ba.firebaseapp.com",
  projectId: "kuramatura-7a9ba",
  storageBucket: "kuramatura-7a9ba.appspot.com",
  messagingSenderId: "443202482105",
  appId: siteConfig.firebase.appId,
  measurementId: siteConfig.firebase.measurementId,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);

const firestore = initializeFirestore(app, {
  localCache: persistentLocalCache()
})

const remoteConfig = getRemoteConfig(app);
remoteConfig.defaultConfig = {
  explain_enabled: false,
};
fetchAndActivate(remoteConfig).catch(() => {});

const firebase = {
    app,
    analytics,
    auth,
    firestore,
    remoteConfig,
}

export default firebase;